import { Component } from '@angular/core';
import {RequestedCreditCard} from './requested-card.model';

@Component({
  selector: 'app-detail-table',
  templateUrl: './requested-card-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})
export class RequestedCreditCardTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: RequestedCreditCard[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }

  public formatDate(date: string): string {
    return '';
  }

  getNotificationDateTime(data:any){
    let notificationDateTime = '-';
    if(data.pinMailer && data.pinMailer.status == 'Verzonden'){
      notificationDateTime = data.pinMailer.notificationDateTime;
    } else if (data.notificationPassFactoryDateTime) {
      notificationDateTime = data.notificationPassFactoryDateTime;
    }
    return notificationDateTime;
  }
}
